import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'

interface ModalAssinanteProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  indiceExcluido: number
  excluirAssinante: (indice: number) => void
}

export const ModalAssinanteExcluido: React.FC<ModalAssinanteProps> = ({ isOpen, onOpen, onClose, indiceExcluido, excluirAssinante }) => {
  function handleExcluirAssinante(): void {
    excluirAssinante(indiceExcluido)
    onClose()
  }
  return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW={'750px'}>
          <ModalHeader color={'red.400'} fontSize={'3xl'} fontWeight={'bold'}>Atenção</ModalHeader>
          <ModalCloseButton color={'black'} bgColor={'white'}/>

          <ModalBody>
            <Box display={'flex'} flexDirection={'column'}>
                <Text fontSize={'lg'} color={'red.400'}>Tem certeza que deseja remover este assinante?</Text>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose} bgColor={'gray.500'} >
              Cancelar
            </Button>
            <Button mr={3} onClick={handleExcluirAssinante} bgColor={'green.500'} >
              Remover
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}
